import { useState } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Alert,
  Tabs,
  Tab,
  Divider,
} from '@mui/material';
import {
  Category as CategoryIcon,
  Key as KeyIcon,
  Tune as TuneIcon,
} from '@mui/icons-material';
import DomainTemplateList from '../components/settings/DomainTemplateList';

function TabPanel({ children, value, index }) {
  return (
    <div role="tabpanel" hidden={value !== index}>
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

function SettingsPage() {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event, newValue) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Settings
      </Typography>

      <Card>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
        >
          <Tab
            icon={<CategoryIcon />}
            iconPosition="start"
            label="Domain Templates"
          />
          <Tab
            icon={<KeyIcon />}
            iconPosition="start"
            label="API Configuration"
            disabled
          />
          <Tab
            icon={<TuneIcon />}
            iconPosition="start"
            label="Application Settings"
            disabled
          />
        </Tabs>

        <CardContent>
          <TabPanel value={currentTab} index={0}>
            <Typography variant="h5" gutterBottom>
              Domain Templates
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <DomainTemplateList />
          </TabPanel>

          <TabPanel value={currentTab} index={1}>
            <Typography variant="h5" gutterBottom>
              API Configuration
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Alert severity="info" sx={{ mb: 2 }}>
              This section will be implemented in a future update.
            </Alert>
            <Typography variant="body2" color="text.secondary" paragraph>
              Configure API keys for transcription services (OpenAI Whisper, Google, AWS, etc.)
            </Typography>
          </TabPanel>

          <TabPanel value={currentTab} index={2}>
            <Typography variant="h5" gutterBottom>
              Application Settings
            </Typography>
            <Divider sx={{ mb: 3 }} />
            <Alert severity="info" sx={{ mb: 2 }}>
              This section will be implemented in a future update.
            </Alert>
            <Typography variant="body2" color="text.secondary">
              Auto-save intervals, file upload limits, and other preferences
            </Typography>
          </TabPanel>
        </CardContent>
      </Card>
    </Box>
  );
}

export default SettingsPage;
